<mat-dialog-title>
  <div class="title text-center mb-4">
    <h1>
      Qual é a probabilidade de recomendar nossa plataforma a um familiar, amigo ou pesquisador?
    </h1>
  </div>
</mat-dialog-title>
<form [formGroup]="form" id="survey-form">
  <div class="d-flex justify-content-between">
    <p>Nem um pouco provável</p>
    <p>Extremamente provável</p>
  </div>
  <div class="d-flex justify-content-between">
    <input type="radio" class="btn-check" name="score" value="0" id="option1" autocomplete="off"
      formControlName="score">
    <label for="option0">0</label>

    <input type="radio" class="btn-check" name="score" value="1" id="option1" autocomplete="off"
      formControlName="score">
    <label for="option1">1</label>

    <input type="radio" class="btn-check" name="score" value="2" id="option2" autocomplete="off"
      formControlName="score">
    <label for="option2">2</label>

    <input type="radio" class="btn-check" name="score" value="3" id="option3" autocomplete="off"
      formControlName="score">
    <label for="option3">3</label>

    <input type="radio" class="btn-check" name="score" value="4" id="option4" autocomplete="off"
      formControlName="score">
    <label for="option4">4</label>

    <input type="radio" class="btn-check" name="score" value="5" id="option5" autocomplete="off"
      formControlName="score">
    <label for="option5">5</label>

    <input type="radio" class="btn-check" name="score" value="6" id="option6" autocomplete="off"
      formControlName="score">
    <label for="option6">6</label>

    <input type="radio" class="btn-check" name="score" value="7" id="option7" autocomplete="off"
      formControlName="score">
    <label for="option7">7</label>

    <input type="radio" class="btn-check" name="score" value="8" id="option8" autocomplete="off"
      formControlName="score">
    <label for="option8">8</label>

    <input type="radio" class="btn-check" name="score" value="9" id="option9" autocomplete="off"
      formControlName="score">
    <label for="option9">9</label>

    <input type="radio" class="btn-check" name="score" value="10" id="option10" autocomplete="off"
      formControlName="score">
    <label for="option10">10</label>
  </div>
</form>
<div class="d-flex justify-content-center align-items-center mt-4">
  <button mat-raised-button type="submit" (click)="onSubmit()" form="survey-form"
    class="button button-green">Enviar</button>
</div>